<template>
  <section
    class="listing-lavorazioni">
    <ul :class="{'listing-lavorazioni--noTouch': !touch}">
      <li
        v-for="(section, index) of hydratedListing"
        v-animate-on-intersection
        :key="index">
        <router-link :to="{ name: `${lang}-lavorazioni-sub`, params: { type: section.slug } }">
          <picture>
            <source :srcset="imgServer + section.processing.mobile" media="(max-width: 639px)">
            <source :srcset="imgServer + section.processing.desktop" media="(min-width: 640px)">
            <img :src="imgServer + section.processing.desktop" :alt="section.title">
          </picture>
          <div class="velina-lavorazioni">
            <img src="/lavorazioni/hover-poligono-page.png">
          </div>
          <!-- <img src="/lavorazioni/hover-poligono.png"> -->
          <div class="default-container">
            <div class="listing-lavorazioni__text-container">
              <span>0{{ index + 1 }}</span>
              <div>
                <h3 v-html="section.title"></h3>
                <p v-html="section.content"></p>
              </div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HeroCta from '@/components/HeroCta'

export default {
  components: {
    HeroCta
  },
  data: () => ({
    loading: true
  }),
  props: {
    list: {
      type: Array,
      default: () => []
    },
    lang: {
      type: String,
      required: true
    },
    background: {
      type: Boolean,
      default: false
    },
    description: {
      type: Boolean,
      default: true
    },
    gallery: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'processingsExcerpts',
      'touch'
    ]),
    hydratedListing: {
      get () {
        return this.processingsExcerpts(this.lang)
      }
    },
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    }
  },
  methods: {
    ...mapActions([
      'loadProcessingsExcerpts'
    ])
  },
  watch: {
    list: {
      async handler (list) {
        this.loading = true
        await this.loadProcessingsExcerpts({
          lang: this.lang,
          filter: list
        })
        this.loading = false
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .listing-lavorazioni {
    ul, li{
      padding: 0; margin: 0;
      list-style: none; list-style-type: none;
    }
    li{
      overflow: hidden;
      .default-container{
        height: 100%;
      }
      picture{
        position: absolute;
        left: 50%; top: 50%;
        width: 100%; height: auto;
        transform: translate3d(-50%, -50%, 0);
        img{
          width: 100%; height: auto;
        }
      }
      a{
        text-decoration: none;
        display: block;
      }
    }
    .listing-lavorazioni__text-container{
      display: flex; width: 100%; height: 100%;
      align-items: center; flex-wrap: nowrap;
      justify-content: flex-start;
      min-height: 140px;
      @media #{$medium_mq} {
        min-height: 280px;
      }

      span{
        font-size: 5rem;
        font-family: 'Sectra', sans-serif;
        font-weight: 300;
        color: #4A4A4A;
        left: -2px;
        @media #{$medium_mq} {
          font-size: 10rem;
        }
        @media #{$large_mq} {
          font-size: 11.5rem;
        }
        @media #{$morelarge_mq} {
          font-size: 13rem;
        }
        @media #{$xlarge_mq} {
          font-size: 16rem;
        }
        @media #{$xxlarge_mq} {
          font-size: 17.5rem;
        }
      }

      div{
        padding: 5px 0 0 25px;
        @media #{$medium_mq} {
          padding: 5px 0 0 50px;
        }
        h3{
          @include size-16-pixel(#EFEFF1);
          letter-spacing: .1rem;
          font-family: 'Roboto', sans-serif;
          font-weight: 500; line-height: 1.4;
          text-transform: uppercase;
          @media #{$medium_mq} {
            letter-spacing: .15rem;
          }
          @media #{$large_mq} {
            letter-spacing: .2rem;
          }
          br{
            display: none;
          }
        }
        p{
          @include size-18-pixel(#EFEFF1);
          line-height: 1.6;
          font-family: 'Roboto', sans-serif;
          font-weight: 300;
          display: none;
          @media #{$medium_mq} {
            display: block;
          }
          br{
            display: none;
            @media #{$medium_mq} {
              display: block;
            }
          }
        }
      }
    }

    li .velina-lavorazioni{
      content: "";
      position: absolute;
      left:0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(29, 29, 27, 1);
      transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
      img{
        height: 100%; width: auto;
        transform: translate3d(-100%, 0, 0);
        transition: all 0 cubic-bezier(0.23, 1, 0.32, 1);
        transition-delay: 0;
      }
    }
  }

  .listing-lavorazioni--noTouch li:hover .velina-lavorazioni{
    background-color: rgba(29, 29, 27, .2);
    img{
      transform: translate3d(0, 0, 0);
      transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
      transition-delay: .1s;
    }
  }
</style>
